import * as Sentry from "@sentry/react";

import axios from "axios";

import { GeomBinListItem, USER_COLUMN_RS_ENDPOINT } from "api/data";

// Callers merge bins into a column list, so a failed read (e.g. a document
// data-svc-rs can't deserialize) must drop only the bins, not that list.
export const fetchGeomBins = async (query: string): Promise<GeomBinListItem[]> => {
  try {
    const response = await axios.get(`${USER_COLUMN_RS_ENDPOINT}/geombins?${query}`);
    // No bins is a 200 with an empty body.
    return response.status === 200 && response.data ? response.data : [];
  } catch (error) {
    Sentry.withScope((scope) => {
      scope.setTag("component", "fetchGeomBins");
      scope.setExtra("query", query);
      Sentry.captureException(error);
    });
    return [];
  }
};
